import { Environments } from '../types/Environments';

export const environments: Environments = {
  items: {
    pending: [],
    completed: []
  },
  fetching: false,
  failed: false
};
